import { concat } from "lodash";

import transportBrand from "./transportBrand";
import transportSupplier from "./transportSupplier";
import cost from "./cost";
import userProfile from "./UsersProfiles";
import log from "./log";
import billingCode from "./billingCode";

import Config from "../../../../pages/Config";

const routesConfig = [{ key: "config", path: "/config", element: <Config />, }]

const routes = concat(
    routesConfig,
    transportBrand,
    transportSupplier,
    cost,
    log,
    userProfile,
    billingCode
)

export default routes